import {Injectable} from "@angular/core";

import {ClientConfiguration} from "../configuration/client.config";
import {CssSentence, CssWord, ContentCssClass} from "../../content/content-view.objects";
import {UserModelService} from "../usermodel/usermodel.service";
import {IReadingMode} from "../../reading/reading.component";
import {ContentCursor, AllowedSelectionType} from "../content/content.cursor";
import {EventBus} from "../../event/EventBus";
import {ContentFormatter} from "../../content/content.formatter";
import {Login} from "../../login/login";
import {AudioQueueService} from "../audio-playback/audioqueue.service";
import {AudioQueueEvent, InterruptAudio} from "../../event/AudioQueueEvent";
import {AudioQueueItem, TranslateAudio} from "../audio-playback/audioqueue.item";

@Injectable()
export class ReadMyRecordingService implements IReadingMode {

    constructor(private audioQueueService:AudioQueueService,
                private login:Login,
                private config:ClientConfiguration,
                private userModelService:UserModelService,
                private contentCursor:ContentCursor,
                private eventBus: EventBus) {
    }

    public sentenceFinishedCallback:Function;

    public startWord(wordItem:CssWord):void {
    }

    public startSentence(sentenceItem:CssSentence, callback:Function):void {
        let httpSessionId:string =  this.login.sessionId;

        // TODO:  This does not appear to be working yet in real mode.
        // I fixed the missing http session id but the sentenceItem.id is
        // incorrect.
        let mp3Path:string =  this.config.isSuperUserMode ?
            this.config.audioUrl + sentenceItem.audio :
            this.config.speechPath + "sentence/" + this.login.tenantId + "/" + this.login.learnerId + "/" +
            this.userModelService.storyUniqName + "/" + sentenceItem.id + "?httpSessionId=" + httpSessionId;

        this.eventBus.next(new AudioQueueEvent(
            [new AudioQueueItem(mp3Path, TranslateAudio.NO, callback)], InterruptAudio.YES));
    }

    public activate(isPipeline: boolean):void {
        this.contentCursor.setMode(ContentCssClass.MODE_PLAY_MY_READING);
        this.formatSelectionColors();
    }

    public pause():void {
        this.audioQueueService.hardReset();
    }

    public get changeUIWhenActive():boolean {
        return false;
    }

    public get allowedSelectionType(): AllowedSelectionType {
        return AllowedSelectionType.SENTENCE;
    }

    private formatSelectionColors(): void {
        ContentFormatter.formatSelectionFromRecordReadingStates(this.contentCursor.selection,
                                                                this.userModelService.recordReadingStates);
    }
}
